<template>
    <div id="wrap">
        <button class="jump" v-show="this.count <= 6" @click="moveMain">
            <em>건너뛰기</em>            
        </button>
        
        <swiper class="swiper swiperWrap" :options="swiperOption">
            <swiper-slide>
                <h3>홈 > 미팅출석</h3>
                <figure><img src="../../assets/images/img_tutorial_01.svg"></figure>
                <span><img src="../../assets/images/img_tutorial_swipe.svg"></span>
            </swiper-slide>
            <swiper-slide>
                <h3>홈 > 하단메뉴</h3>
                <figure><img src="../../assets/images/img_tutorial_02.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>고객등록</h3>
                <figure><img src="../../assets/images/img_tutorial_03.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>내고객보기</h3>
                <figure><img src="../../assets/images/img_tutorial_04.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>내고객보기 > 상세검색</h3>
                <figure><img src="../../assets/images/img_tutorial_05.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>에듀플랜맵</h3>
                <figure><img src="../../assets/images/img_tutorial_06.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>에듀플랜맵 > 장바구니</h3>
                <figure><img src="../../assets/images/img_tutorial_07.svg"></figure>
            </swiper-slide>
            <swiper-slide>
                <h3>영업활동계획</h3>
                <figure><img src="../../assets/images/img_tutorial_08.svg"></figure>
            </swiper-slide>  
            <div class="swiper-pagination swiperOption" slot="pagination"></div>
        </swiper>

        <button class="start" v-show="this.count >= 7" @click="moveMain"><img src="../../assets/images/btn_start.svg"></button>
    </div>   
</template>

<script>
export default {
  data() {
    var self = this; 
    return {
        count: 0,
        swiperOption: {
          pagination: {
            el: '.swiperOption'
          },
          on: {
            slideChange() {
              self.count = this.realIndex
            }
          }
        },
    }
 },
  methods: { 
    moveMain: function () {
      this.$router.push({ name: "main" }).catch(function() {});
    }
  },
};
</script>
<style scoped>
    html, body, #Waple {background-color: #F5F5F5 !important;}
    #wrap {position: relative;padding-top: 30px;height: 100%;box-sizing: border-box;background-color: #F5F5F5 !important;}
    #wrap button.jump {position: absolute;right: 20px;top: 30px;font-size: 12px;background-color: #F5F5F5;z-index: 10;}
    #wrap button.jump em {border-bottom: 1px solid rgb(102,102,102);}
    #wrap button.start {display: block;margin: 15px auto 0;}
    #wrap h3 {margin: 0 0 20px 20px;font-weight: 600;font-size: 18px;}
    #wrap figure {margin: 0 auto;width: 290px;}
    #wrap figure img {width: 100%;}
    #wrap .swiper-slide span {position: absolute;right: 30px;top: 50%; width: 92px;height: 48px;transform: translateY(30px)}
    #wrap .swiper-slide span img {width: 100%;}
    .swiper-container {padding-bottom: 30px !important;}
@media screen and (max-width: 512px) { 
    #wrap {padding-top: 8vw;}
    #wrap button.jump {right: 5.3333vw;top: 8vw;font-size: 3.2000vw;}
    #wrap button.start {margin-top: 4vw;}
    #wrap h3 {margin: 0 0 5.3333vw 5.3333vw;font-size: 4.8000vw;}
    #wrap figure {width: 77.3333vw;}
    #wrap .swiper-slide span {right: 8.0000vw;width: 24.5333vw;height: 12.8000vw;transform: translateY(8.0000vw)}
}
</style>

